import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ palette, custom, breakpoints }: Theme) => ({
    root: {
      fontFamily: 'Lato',
      maxWidth: 600,
    },
    descriptionContainer: {
      maxWidth: 1200,
      margin: '0 auto',
    },
    fullWidth: {
      position: 'relative',
      marginRight: 'calc(-395px - max(calc(100vw - 1060px), 0px))',
      maxWidth: 1160,
      marginLeft: 0,
      [breakpoints.down(1024)]: {
        maxWidth: '100%',
      },
    },
    expandableContentSectionHeader2: {
      color: palette.primary.main,
      fontSize: 18,
      lineHeight: 1.33,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0 40px',
      '& svg': {
        marginRight: 15,
      },
      [breakpoints.down(485)]: {
        padding: '10px 0 30px',
      },
    },
    expandableContentSectionHeader4: {
      fontFamily: 'Merriweather',
      color: custom.grey[3],
      fontSize: 22,
      fontWeight: 900,
      lineHeight: 1.36,
      margin: 0,
      padding: '2px 0 20px',
    },
    expandableContentSectionHeader3: {
      color: custom.grey[3],
      fontSize: 18,
      fontWeight: 'bold',
      lineHeight: 1.33,
      margin: 0,
      padding: '20px 0',
    },
    expandableContentSectionParagraph: {
      color: custom.grey[3],
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: 1.43,
      textAlign: 'justify',
      margin: '0 0 20px',
      '& ul': {
        paddingLeft: 20,
        margin: 0,
      },
    },
    sectionContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      '&>p': {
        margin: '0 0 20px',
        fontSize: 14,
        lineHeight: 1.43,
        color: custom.grey[3],
      },
    },

    descriptionBox: {
      [breakpoints.down(769)]: {
        borderTop: `1px solid ${custom.grey[1]}`,
      },
    },
    withBorderTop: {
      borderTop: `1px solid ${custom.grey[1]}`,
    },
    textBold: {
      fontWeight: 'bold',
    },
    link: {
      color: custom.grey[3],
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
    icon: {
      width: 24,
      height: 24,
    },
    backToBeginButton: {
      fontSize: 16,
      lineHeight: 22,
      padding: '12px 30px',
      borderRadius: 8,
      marginTop: 20,
      [breakpoints.down(485)]: {
        width: '100%',
      },
    },
    warrantyAndPaymentListWrapper: {
      maxWidth: 600,
    },
    warrantyContainer: {
      marginTop: 10,
    },
  })
);
